export const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const MEAL_PERIODS = [
  { value: 'Breakfast', label: 'Breakfast (5–11 AM)' },
  { value: 'Lunch', label: 'Lunch (11 AM–4 PM)' },
  { value: 'Dinner', label: 'Dinner (4–10 PM)' },
  { value: 'Late Night', label: 'Late Night (10 PM–5 AM)' },
];
export const MEALS = MEAL_PERIODS.map(period => period.value);
export const ymd = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const parseDay = value => new Date(`${value}T12:00:00`);
export const shiftDay = (value, offset) => { const date = parseDay(value); date.setDate(date.getDate() + offset); return ymd(date); };
export const dateLabel = value => parseDay(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
export const monday = value => shiftDay(value, -((parseDay(value).getDay() + 6) % 7));
export const sumOrders = rows => rows.reduce((sum, row) => sum + (Number(row.total_orders) || 0), 0);

// Preserve explicit zero counts; missing dates and invalid counts remain null.
export function weekdayTrends(rows, start, end) {
  const counts = new Map(rows.map(row => {
    const value = row.total_orders;
    const count = value == null || typeof value === 'boolean' || String(value).trim() === '' ? null : Number(value);
    return [String(row.date).slice(0, 10), Number.isFinite(count) && count >= 0 ? count : null];
  }));
  const weeks = new Map();
  for (let date = start; date <= end; date = shiftDay(date, 1)) {
    const week = monday(date);
    if (!weeks.has(week)) weeks.set(week, { week_start: week, ...Object.fromEntries(WEEKDAYS.map(day => [day, null])) });
    weeks.get(week)[WEEKDAYS[(parseDay(date).getDay() + 6) % 7]] = counts.get(date) ?? null;
  }
  return [...weeks.values()];
}
